import WorkerPoolsLayout from "./WorkerPoolsLayout";

export default WorkerPoolsLayout;